import { render, staticRenderFns } from "./TaskSyncLogPopup.vue?vue&type=template&id=4fc2c804&"
import script from "./TaskSyncLogPopup.vue?vue&type=script&lang=ts&"
export * from "./TaskSyncLogPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports